export default {_name:'button.fab',module:'Field',view:'Element/Button/Fab',options:{xs:'auto',ms:'auto'}}